<template>
	<div class="basic_wrap">
        <bsHeader title="PDF" @backurl="$router.back()"></bsHeader>
        <iframe :src="pdfLink" width="100%" class="iframe"></iframe>
	</div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import bsHeader from '../../components/bsHeader.vue'
import {
	Field
} from 'vant';
Vue.use(Field);
export default {
	name: "",
    components: {
         bsHeader
    },
	data() {
		return {
			commonMoney: [],
			userBalance: '',
			money: '',
			rechargeMethod: [],
			active: 0,
			active_money: -1,
			minMoney: 0,
			type: 1,
			type3: 1,
			currentInfo: null,
            pdfLink: '',
            
		};
	},
	created() {
		
		this.$parent.footer('user', false);
	},
	mounted() {
		this.pdfLink = this.$route.params.pdfLink;
	},	
};
</script>

<style lang="less" scoped>
.iframe{
    height: 100vh;
}

.basic_wrap {
	margin-bottom: 70px;
}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
	background-color: #FFFFFF;

	.record {
		position: absolute;
		top: 11px;
		right: 15px;

		img {
			width: 22px;
			height: 22px;
		}
	}
}

.recharge_wrap {
	margin-top: 12px;

	.tips {
		margin-bottom: 20px;
		font-size: 14px;
		color: #999;
	}

	.common_money_wrap {
		padding: 20px;
		margin-bottom: 10px;

		.common_money {
			justify-content: space-around;

			p {
				padding: 12px 8px;
				margin-left: 5px;
				background: #dfdfdf;
				border-radius: 5px;
			}

			.active_money {
				background: #1989fa;
				color: #FFFFFF;
			}
		}

	}

	.recharge_money_wrap {
		padding: 20px;
		margin-bottom: 10px;
		font-size: 14px;
		color: #999;
	}

	.recharge_detail_wrap {
		position: fixed;
		bottom: 0px;
		width: 100%;
		margin: 0;
		justify-content: space-between;
		padding: 15px;
		max-width: 750px;

		.detail_money {
			color: #FF0000;
			font-weight: bold;
			font-size: 16px;
			margin-left: 5px;
		}

		.btn {
			width: unset;
			height: unset;
			line-height: unset;
			padding: 5px 15px;
			margin-left: unset;
		}
	}
}
</style>
